import type { Resolve } from '@doxyme/types';
import { type KeyboardEvent, type CSSProperties, type JSX } from 'react';
import { Popover, type PopoverProps } from '../popover';
import { useContextMenuStyles } from './contextMenu.styles';

export type ContextMenuProps = Resolve<
  Pick<
    PopoverProps,
    | 'children'
    | 'anchorElement'
    | 'openerElement'
    | 'placement'
    | 'isOpen'
    | 'onClose'
    | 'offset'
    | 'skidding'
    | 'flipPadding'
    | 'className'
    | 'preventScrollOnFocus'
    | 'disablePortal'
  > & {
    containerCss?: CSSProperties;
    /**
     * Disable the scale up animation for the context menu.
     * Needed for the context menu to be used in a call control bar.
     */
    disableAnimation?: boolean;
  }
>;

export const ContextMenu = ({
  children,
  className,
  disableAnimation,
  ...rest
}: ContextMenuProps): JSX.Element => {
  const styles = useContextMenuStyles({
    disableAnimation,
  });

  function onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      rest.onClose?.();
    }
  }

  return (
    <Popover {...rest}>
      <div
        role='menu'
        tabIndex={-1}
        className={className}
        css={styles.container}
        onClick={() => rest.onClose?.()}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
    </Popover>
  );
};
